import { createFileRoute, redirect } from '@tanstack/react-router'
import { RequestInboxPage } from '@/pages/ClientConfig/RequestInboxPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/client-config')({
  component: RequestInboxPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/client-config')) {
      throw redirect({ to: '/' })
    }
  },
})
